import React from "react";

import Carousel from "@/src/components/common/carousel";
import TaggedProductCard from "@/src/components/blog/taggedProductCard";

const TaggedProduct = ({ data }) => {
    return (
        <div className="md:py-0 py-1">
            <div className="max-w-6xl mx-auto">
                <Carousel
                    settings={{
                        speed: 700,
                        slidesToShow: 3,
                        slidesToScroll: 2,
                        responsive: [
                            {
                                breakpoint: 600,
                                settings: {
                                    slidesToShow: 1, // Show 1 slide on smaller screens
                                },
                            },
                        ],
                    }}
                >
                    {data?.length > 0 &&
                        data.map((item, index) => (
                            <TaggedProductCard
                                key={index}
                                item={item}
                                isSpacing={true}
                            />
                        ))}
                </Carousel>
            </div>
        </div>
    );
};

export default TaggedProduct;
